import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'reactstrap';
import AssessmentEditDialogHeader from './AssessmentViewDialogHeader';
import api from '@/utils/apiClient';
import { AssessmentViewBasicDetails } from './AssessmentViewBasicDetails';
import { AssessmentViewTabs } from './AssessmentViewTabs';
import LoadingIcon from 'mdi-react/LoadingIcon';

const AssessmentViewDialog = ({ show, onHide, id, rtl }) => {
  const [modal, setModal] = useState({
    isOpen: show,
    title: 'View Assessment',
    hide: onHide,
  });

  const [state, setState] = React.useState({
    loading: false,
    assessment: {},
    error: '',
  });

  React.useEffect(() => {
    if (id) getAssessmentById(+id);
  }, [id]);

  const getAssessmentById = async (assessmentId) => {
    try {
      setState({ ...state, loading: true });
      const { data: res, isSuccess } = await api.assessments.getAssessmentById(assessmentId);
      if (isSuccess) {
        setState({ ...state, loading: false, assessment: res.data, error: '' });
      } else {
        throw new Error(res?.messages?.[0] ?? 'Error while getting assessment details');
      }
    } catch ({ message }) {
      setState({ ...state, loading: false, assessment: {}, error: message });
      console.error(message);
    }
  };

  const { error, loading, assessment } = state;

  return (
    <Modal
      isOpen={show}
      toggle={modal.hide}
      modalClassName={`${rtl.direction}-support`}
      className="modal-dialog--primary modal-dialog--header modal-view-dialog"
    >
      <AssessmentEditDialogHeader modal={modal} assessment={assessment} />
      {/*Assessment Modal Body*/}
      <div style={{ padding: 15 }}>
        {loading || !!error ? (
          <>
            {loading && (
              <div className="panel__refresh position-relative" style={{ height: 75 }}>
                <LoadingIcon />
              </div>
            )}
            <div className="text-center">
              {error && (
                <div>
                  <span className="lnr lnr-cross-circle modal__title-icon error" />
                </div>
              )}
              {loading ? 'Getting assessment details...' : error}
            </div>
          </>
        ) : (
          <>
            <AssessmentViewBasicDetails assessment={assessment} />
            <AssessmentViewTabs assessment={assessment} />
          </>
        )}
      </div>
    </Modal>
  );
};

export default connect((state) => ({
  rtl: state.rtl,
}))(AssessmentViewDialog);
